import { ItemId, ItemSettingDataObject, UserSettingEnum } from 'able-lib'

export function isObjectHas (object, key) {
  return Object.prototype.hasOwnProperty.call(object, key)
}

export function removeItemSettingByKeyTemplate (itemId, key) {
  return {
    item_id: { _eq: itemId },
    key: { _eq: key },
    user_id: { _neq: 0 }
  }
}

export function removeItemSettingByIdTemplate (itemId, key, userId) {
  userId = Number.parseInt(userId)
  return {
    item_id: { _eq: itemId },
    key: { _eq: key },
    user_id: { _eq: userId }
  }
}

export function removeUserSettingByKey (userSettings, itemId, itemKey) {
  const personalSetting = []
  for (const userId in userSettings) {
    if (userId === '0') continue
    if (isObjectHas(userSettings[userId], itemKey)) personalSetting.push(removeItemSettingByIdTemplate(itemId, itemKey, userId))
  }
  return personalSetting
}

export function preparePersonalSessionSetting (itemId: ItemId, userSettings, itemSettings: Array<ItemSettingDataObject>) {
  let removeUserSettings = []
  const upsertSettings = []

  for (const itemSetting of itemSettings) {
    if (!Object.values(UserSettingEnum).includes(itemSetting.key as UserSettingEnum)) {
      upsertSettings.push(itemSetting)
    } else {
      const itemSettingValue = itemSetting.value.value
      const usersPersonalSettings = {}
      for (const userId in userSettings) {
        if (userId !== '0' && Object.prototype.hasOwnProperty.call(userSettings[userId], itemSetting.key)) {
          usersPersonalSettings[userId] = userSettings[userId]
        }
      }

      if (itemSetting.user_id === 0) {
        console.log('Action is for default setting')
        if (Object.prototype.hasOwnProperty.call(userSettings, '0')) {
          console.log('We have default setting')
          if (itemSettingValue !== userSettings['0'][itemSetting.key]) { // not same value
            console.log('Action value and default are not the same')
            if (Object.keys(usersPersonalSettings).length > 0) {
              console.log('We have personal setting')
              if (itemSettingValue === false) {
                console.log('Action value is false, means to update and remove personal settings')
                upsertSettings.push(itemSetting)
                removeUserSettings.push(removeItemSettingByKeyTemplate(itemId, itemSetting.key))
              } else if (userSettings['0'][itemSetting.key] === false) {
                console.log('Default value is false, means don\'t update and remove personal settings')
                removeUserSettings.push(removeItemSettingByKeyTemplate(itemId, itemSetting.key))
              }
            } else {
              console.log('No personal setting. only update')
              upsertSettings.push(itemSetting)
            }
          } else {
            console.log('Action value and default are the same')
            if (Object.keys(usersPersonalSettings).length > 0) {
              console.log('We have personal setting')
              if (itemSettingValue === false) {
                console.log('Action value is false, means remove personal settings')
                removeUserSettings.push(removeItemSettingByKeyTemplate(itemId, itemSetting.key))
              }
            }
          }
        } else {
          console.log('No default setting, means only need to upsert')
          upsertSettings.push(itemSetting)

          if (Object.keys(usersPersonalSettings).length > 0) {
            console.log('We have personal setting')
            if (itemSettingValue === false) {
              console.log('Action value is false, means remove personal settings')
              removeUserSettings.push(removeItemSettingByKeyTemplate(itemId, itemSetting.key))
            }
          }
        }
      } else {
        console.log('Actions is for personal setting')
        if (Object.prototype.hasOwnProperty.call(usersPersonalSettings, itemSetting.user_id + '')) {
          console.log('We have personal setting')
          if (Object.prototype.hasOwnProperty.call(usersPersonalSettings[itemSetting.user_id], itemSetting.key)) {
            if (itemSettingValue !== usersPersonalSettings[itemSetting.user_id][itemSetting.key]) {
              removeUserSettings = removeUserSettings.concat(removeItemSettingByIdTemplate(itemId, itemSetting.key, itemSetting.user_id))
            }
          } else {
            upsertSettings.push(itemSetting)
          }
        } else {
          upsertSettings.push(itemSetting)
        }
      }
    }
  }

  return {
    removeUserSettings,
    upsertSettings
  }
}
